import script from "./MenuPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuPage.vue?vue&type=script&setup=true&lang=js"

import "./MenuPage.vue?vue&type=style&index=0&id=19a7eef6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a7eef6"]])

export default __exports__